import { instance } from "libs/api";

import { ApiRoutesBoxMovements } from "../../constants";
import { BoxMovementSummary } from "../../transfers.types";

export const requestGetBoxMovementSummary =
  async (): Promise<BoxMovementSummary> => {
    return await instance.get(`${ApiRoutesBoxMovements.BoxMovements}/summary`);
  };
